import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

interface Flight {
    "company name": string;
    date: string;
    price: number;
    destination: string;
    reanalysis?: boolean,
    priceRaise?: boolean,
    priceReduction?: boolean

}

interface PriceAnalysisProps {
    data: Flight[];
}

enum Airlines {
    EL_AL = "El Al Israel",
    OTHER = "Other Airlines"
}

const PriceAnalysis: React.FC<PriceAnalysisProps> = ({ data }) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const chartInstanceRef = useRef<Chart | null>(null);

    useEffect(() => {
        if (chartInstanceRef.current) {
            chartInstanceRef.current.destroy();
        }

        const counts = {
            priceRaise: 0,
            priceReduction: 0,
            reanalysis: 0
        };

        data.forEach(entry => {
            if (entry.priceRaise) counts.priceRaise++;
            else if (entry.priceReduction) counts.priceReduction++;
            else if (entry.reanalysis) counts.reanalysis++;
        });

        const labels = ['Price Raise', 'Price Reduction', 'Re-analysis'];
        const dataset = [counts.priceRaise, counts.priceReduction, counts.reanalysis];
        const backgroundColors = [ 'rgb(47 94 146)','rgb(255,61,61)', 'rgba(255,179,65,0.61)'];
        const borderColors = [ 'rgb(0,48,96)','rgb(148,0,0)', 'rgba(136,80,0,0.61)'];

        // @ts-ignore
        const ctx = canvasRef.current.getContext('2d');
        // @ts-ignore
        new Chart(ctx, {
            type: 'doughnut', // Change this from 'pie' to 'doughnut'
            data: {
                labels: labels,
                datasets: [{
                    data: dataset,
                    backgroundColor: backgroundColors,
                    borderColor: borderColors,
                    borderWidth: 1
                }]
            },
            options: {
                plugins: {
                    title: {
                        display: true,
                        text: 'Price Adjustment Distribution',
                        font: {
                            size: 20
                        },
                        padding: {
                            top: 20,
                            bottom: 30
                        }
                    },
                    legend: {
                        display: true,
                        position: 'bottom',
                        labels: {
                            font: {
                                size: 14
                            },
                            usePointStyle: true,
                            padding: 20
                        }
                    },
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                const label = context.label || '';
                                // @ts-ignore
                                const value:number = context.raw || 0;
                                const total = context.dataset.data.reduce((sum, val) => sum + val, 0);
                                const percentage = ((value / total) * 100).toFixed(2);
                                return `${label}: ${value} (${percentage}%)`;
                            }
                        }
                    }
                }
            },
            plugins: [{
                afterDraw: chart => {
                    let ctx = chart.ctx;
                    ctx.save();
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    ctx.font = '16px Arial';
                    ctx.fillStyle = 'black';
                    const centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
                    const centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
                    ctx.fillText('Actions', centerX, centerY);
                    ctx.restore();
                }
            }]
        });


        return () => {
            if (chartInstanceRef.current) {
                chartInstanceRef.current.destroy();
            }
        };
    }, [data]);

    return (
        <div>
            <canvas ref={canvasRef} width="800" height="800"></canvas>
        </div>
    );
};

export default PriceAnalysis;
